














import { Component, Mixins, Prop } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GExamDetailProgressChart',
  computed: {},
  methods: {},
})
export default class GExamDetailProgressChart extends Mixins(GPageBase) {
  chartOptions: any = {};

  @Prop({ default: true }) isShow: boolean;
  @Prop() title: string;
  @Prop() progressPercent: number;
  @Prop() completedCount: number;
  @Prop() overallCount: number;
  @Prop({ default: 50 }) outerRadius: number;
  @Prop({ default: 40 }) innerRadius: number;
  @Prop() height: number;
  @Prop({ default: GEnum.ColorType.Blue }) colorType: GEnum.ColorType;
  @Prop({ default: 50 }) labelMargin: number;

  mounted() {
    const self: any = this;
    const progressPercent: number = this.percentFloor(this.completedCount / this.overallCount);
    let fontSize: number = 20;
    // 桁揃え用
    const len: number =
      String(this.overallCount - this.completedCount).length > String(this.completedCount).length ? String(this.overallCount - this.completedCount).length : String(this.completedCount).length;
    const colors: any = {
      red: {
        main: '#f5222d',
        sub: '#ffccc7',
      },
      blue: {
        main: '#1890ff',
        sub: '#bae7ff',
      },
      green: {
        main: '#52c41a',
        sub: '#d9f7be',
      },
      purple: {
        main: '#722ed1',
        sub: '#efdbff',
      },
      orange: {
        main: '#fa8c16',
        sub: '#ffe7ba',
      },
    };

    let circleColor: any;

    if (this.outerRadius > 100) {
      fontSize = 40;
    }

    switch (this.colorType) {
      case GEnum.ColorType.Blue:
        circleColor = colors.blue;
        break;
      case GEnum.ColorType.Green:
        circleColor = colors.green;
        break;
      case GEnum.ColorType.Orange:
        circleColor = colors.orange;
        break;
      case GEnum.ColorType.Purple:
        circleColor = colors.purple;
        break;
      case GEnum.ColorType.Red:
        circleColor = colors.red;
        break;
    }

    this.chartOptions = {
      title: {
        text: this.title,
        x: 'center',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}名',
      },
      legend: {
        orient: 'vertical',
        x: 'right',
        y: 'bottom',
        data: [this.$t('COMPLETED').toString(), this.$t('UNCOMPLETED').toString()],
        textStyle: {
          fontSize: 14,
        },
        formatter: function(name: string): string {
          let count: number;
          let data: any = self.chartOptions.series[0].data;
          data.forEach((d: any) => {
            if (d.name === name) {
              count = d.value;
            }
          });
          return `${name}：${('$'.repeat(len) + count).slice(-len).replace(/\$/g, '  ')}`;
        },
      },
      series: [
        {
          name: 'progress',
          type: 'pie',
          radius: [this.innerRadius, this.outerRadius],
          center: ['50%', `${this.labelMargin}%`],
          data: [
            {
              value: this.completedCount,
              name: this.$t('COMPLETED').toString(),
              label: {
                normal: {
                  formatter: function(params: any) {
                    return progressPercent + '%';
                  },
                  position: 'center',
                  show: true,
                  textStyle: {
                    fontSize: fontSize,
                    fontWeight: 'bold',
                    color: circleColor.main,
                  },
                },
              },
            },
            {
              value: this.overallCount - this.completedCount,
              name: this.$t('UNCOMPLETED').toString(),
              itemStyle: {
                normal: {
                  color: circleColor.sub,
                },
              },
            },
          ],
          itemStyle: {
            normal: {
              color: circleColor.main,
              shadowColor: circleColor.main,
              shadowBlur: 0,
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  }

  percentFloor(ratio: number): number {
    return Math.floor(ratio * 100);
  }
}
